import React, { useEffect, useState } from "react";
import moment from "moment";
import axios from "axios";
import {
  GetconsentManagement,
  GetPatientSign,
  UpdatePatientSign,
} from "../../api/helper";
import { ShowToast } from "../../helpers/ToastService";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const ConsentForms = ({ data, appointmentdetail, onComplete }) => {
  const [consentdata, setconsentdata] = useState([]);
  const [ismodal, setIsModal] = useState(false);
  const [signmodal, setsignmodal] = useState(false);
  const [selectedConsent, setSelectedConsent] = useState(null);
  const [selectedTitle, setselectedTitle] = useState(null);
  const [signdata, setsigndata] = useState([]);
  const [checkingbox, setCheckingbox] = useState(false);
  const [signedBy, setSignedBy] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = () => {
    onComplete?.(true);
  };

  const FetchConsentManagement = async () => {
    try {
      setIsLoading(true);
      const respo = await GetconsentManagement(appointmentdetail?.agencyId);
      setconsentdata(respo?.data?.data?.data || []);
    } catch (error) {
      console.error("Error fetching consents:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (appointmentdetail?.agencyId) {
      FetchConsentManagement();
    }
  }, [appointmentdetail?.agencyId]);

  const dob = new Date(appointmentdetail?.dob);

  const openModal = async (item) => {
    setIsModal(true);
    setSelectedConsent(item);
    setIsLoading(true);
    try {
      const respo = await GetPatientSign(data?.patientId, item?._id);
      setsigndata(respo?.data?.data?.data || []);
    } catch (error) {
      console.error("Error fetching signature data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    setCheckingbox(false);
    setSignedBy("");
    setsigndata([]);
    setIsModal(false);
    setSelectedConsent(null);
  };

  const openSignModal = (item) => {
    const hasMatchingConsent = item?.informedConsent?.find(
      (consent) =>
        consent.agencyId === appointmentdetail?.agencyId &&
        consent.patientId === data?.patientId
    );
    setSelectedConsent(hasMatchingConsent || null);
    setselectedTitle(item);
    setCheckingbox(false);
    setSignedBy("");
    setsignmodal(true);
  };

  const closeSIgnModal = () => {
    setsignmodal(false);
    setCheckingbox(false);
    setSignedBy("");
    setsigndata([]);
    setselectedTitle(null);
    setSelectedConsent(null);
  };

  const AddSignofpatient = async () => {
    if (!checkingbox) {
      ShowToast("Please check the consent box before signing.");
      return;
    }
    if (!signedBy.trim()) {
      ShowToast("Please add your signature.");
      return;
    }

    let ipAddress = "";
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    try {
      const ipResponse = await axios.get("https://api.ipify.org?format=json");
      ipAddress = ipResponse.data.ip || "unknown";
    } catch (error) {
      console.warn("Failed to fetch IP address:", error);
      ipAddress = "unknown";
    }

    const paramdata = {
      consentManagementId: selectedConsent?.consentManagementId,
      agencyId: appointmentdetail?.agencyId,
      patientId: data?.patientId,
      signedDate: new Date().toISOString(),
      Signedby: signedBy.trim(),
      checkingbox: true,
      ipAddress,
      timeZone,
    };

    try {
      const respo = await UpdatePatientSign(paramdata, selectedConsent?._id);
      ShowToast(respo?.data?.message || "Consent signed successfully");
      closeSIgnModal();
      FetchConsentManagement();
    } catch (error) {
      console.error("Error updating patient signature:", error);
      ShowToast("Failed to sign consent.");
    }
  };
  const downloadConsentPdf = async (consent) => {
    const doc = new jsPDF();
    let y = 10;

    doc.setFontSize(16);
    doc.text("Consent Form", 14, y);
    y += 10;

    doc.setFontSize(12);
    doc.text(`Title: ${consent.Title}`, 14, y);
    y += 8;
    doc.text(`Category: ${consent.Category}`, 14, y);
    y += 8;
    doc.text(
      `Agency Name: ${consent?.agency?.firstName || ""} ${
        consent?.agency?.lastName || ""
      }`,
      14,
      y
    );
    y += 8;
    doc.text(
      `Patient Name: ${data?.firstName || ""} ${data?.lastName || ""}`,
      14,
      y
    );
    y += 10;

    // Add consent HTML content as plain text (strip HTML tags)
    const plainTextContent = consent.Content.replace(/<[^>]+>/g, "");
    const lines = doc.splitTextToSize(plainTextContent, 180);
    doc.text(lines, 14, y);
    y = doc.lastAutoTable
      ? doc.lastAutoTable.finalY + 10
      : y + lines.length * 7;

    // Signature Info
    const sigInfo = consent.informedConsent?.find(
      (c) =>
        c.agencyId === appointmentdetail?.agencyId &&
        c.patientId === data?.patientId
    );

    if (sigInfo) {
      y += 10;
      doc.setFontSize(14);
      doc.text("Signature Details", 14, y);
      y += 8;
      doc.setFontSize(12);
      doc.text(`Signed By: ${sigInfo?.Signedby || "N/A"}`, 14, y);
      y += 8;
      doc.text(
        `Signed Date: ${
          sigInfo?.signedDate
            ? moment(sigInfo.signedDate).format("DD/MM/YYYY hh:mm A")
            : "N/A"
        }`,
        14,
        y
      );
      y += 8;
      doc.text(`IP Address: ${sigInfo?.ipAddress || "N/A"}`, 14, y);
      y += 8;
      doc.text(`Time Zone: ${sigInfo?.timeZone || "N/A"}`, 14, y);
      y += 8;
      doc.text(
        `Checked Consent Box: ${sigInfo?.checkingbox ? "Yes" : "No"}`,
        14,
        y
      );
    }

    doc.save(`${consent.Title.replace(/\s+/g, "_")}.pdf`);
  };

  // console.log(selectedConsent, "selectedConsent====");
  return (
    <>
      <div className="basic-info-form">
        <h2>Basic Info Form</h2>
        <div className="form-description">
          Please complete the Basic Info form. All fields marked with * are
          required.
        </div>
        <>
          <div style={{ textAlign: "left" }}>
            Please review and sign each consent below. You can also download a
            PDF copy.
          </div>
          <table className="table_verify">
            <thead>
              <tr>
                <th>Consent Title</th>
                <th>Status</th>
                <th>Sign Status</th>
                
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {consentdata.filter((item) => item.status !== "Inactive")
                .length === 0 ? (
                <tr>
                  <td colSpan="4">No active consent found</td>
                </tr>
              ) : (
                consentdata
                  .filter((item) => item.status !== "Inactive")
                  .map((item) => {
                    const hasMatchingConsent = item?.informedConsent?.find(
                      (consent) =>
                        consent.agencyId === appointmentdetail?.agencyId &&
                        consent.patientId === data?.patientId
                    );
                    return (
                      <tr key={item._id}>
                        <td>{item.Title}</td>
                        <td
                          className={
                            item.status === "active"
                              ? "status-signed"
                              : "status-sent"
                          }
                        >
                          {item.status}
                        </td>
                        <td>
                          {hasMatchingConsent ? (
                            hasMatchingConsent.Signedby ? (
                              <span>Signed</span>
                            ) : (
                              <span>Not Signed</span>
                            )
                          ) : (
                            <span>Not Signed</span>
                          )}
                        </td>
                        <td>
                          <button
                            className="view-btn"
                            onClick={() => openModal(item)}
                            style={{ width: 100 }}
                          >
                            View
                          </button>
                          {item.status === "active" && (
                            <button
                              className="download-btn"
                              style={{ marginLeft: 10 }}
                              onClick={() => downloadConsentPdf(item)}
                            >
                              Download PDF
                            </button>
                          )}
                          {hasMatchingConsent &&
                            !hasMatchingConsent.Signedby && (
                              <button
                                className="save-button_Vitals"
                                style={{
                                  marginLeft: 10,
                                  backgroundColor: "green",
                                  color: "white",
                                }}
                                onClick={() => openSignModal(item)}
                              >
                                View Signature Request
                              </button>
                            )}
                        </td>
                      </tr>
                    );
                  })
              )}
            </tbody>
          </table>
        </>
        <button
          className="cta-button"
          id="completeForm"
          type="button"
          style={{ marginTop: 20, width: "100%" }}
          onClick={handleSave}
        >
          Save
        </button>
        {ismodal && selectedConsent && (
          <div className="modal_Consent">
            {isLoading && (
              <div className="modal_Consent_loader">
                <div className="spinner"></div>
              </div>
            )}
            <div
              style={{
                fontSize: "20px",
                cursor: "pointer",
                width: 50,
                position: "absolute",
                right: 10,
                top: 10,
                zIndex: 1001,
              }}
            >
              <span className="close" onClick={closeModal}>
                &times;
              </span>
            </div>
            <div
              style={{
                alignItems: "flex-start",
                display: "flex",
                flexDirection: "column",
                padding: "20px",
                maxHeight: "80vh",
                overflowY: "auto",
              }}
            >
              <h1>Informed Consent for Treatment</h1>
              <p>
                <strong>Category:</strong> {selectedConsent.Category}
              </p>
              <p>
                <strong>Consent Title:</strong> {selectedConsent.Title}
              </p>
              <p>
                <strong>Client Name:</strong>{" "}
                {"info?.firstName" + " " + "info?.lastName"}
              </p>
              <p>
                <strong>Agency Name:</strong>{" "}
                {selectedConsent.agency?.firstName +
                  " " +
                  selectedConsent.agency?.lastName}
              </p>
              <p style={{ textAlign: "left" }}>
                <strong>Consent Details:</strong>{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: selectedConsent.Content }}
                />
              </p>

              <div
                className="signature-section"
                style={{ marginTop: 20, textAlign: "left" }}
              >
                <h2 style={{ textAlign: "left" }}>Signature:</h2>
                {signdata.length > 0 && signdata[0].Signedby ? (
                  <>
                    <p>
                      <strong>Signed by:</strong> {signdata[0].Signedby}
                    </p>
                    <p>
                      <strong>Date and Time:</strong>{" "}
                      {signdata[0].signedDate
                        ? moment(signdata[0].signedDate).format(
                            "DD/MM/YYYY hh:mm A"
                          )
                        : "N/A"}
                    </p>
                    <p>
                      <strong>IP Address:</strong>{" "}
                      {signdata[0].ipAddress || "N/A"}
                    </p>
                    <p>
                      <strong>Time Zone:</strong>{" "}
                      {signdata[0].timeZone || "N/A"}
                    </p>
                    <p>
                      <strong>Checked Consent Box:</strong>{" "}
                      {signdata[0].checkingbox ? "Yes" : "No"}
                    </p>
                  </>
                ) : (
                  <p>No signature information found.</p>
                )}
              </div>
            </div>
          </div>
        )}

        {signmodal && selectedTitle && (
          <div className="modal_verify">
            <div className="modal-content_verify">
              <button className="close_verify" onClick={closeSIgnModal}>
                ×
              </button>

              <h3 className="header_text_style">
                Electronic Communication Consent
              </h3>
              <div className="info-section">
                <p>
                  <strong>Agency Name:</strong>{" "}
                  {selectedTitle?.agency?.firstName}{" "}
                  {selectedTitle?.agency?.lastName}
                </p>
                <p>
                  <strong>Patient Name:</strong> (Your Name Here)
                </p>
                <p>
                  <strong>Provider Name:</strong> Nagely Michel, DNP
                </p>
              </div>

              <hr />

              <div className="consent-text">
                <p>
                  By consenting to electronic communication, you acknowledge...
                  <br />
                  (Add relevant text here)...
                </p>
              </div>

              <div className="consent-checkbox">
                <label>
                  <input
                    id="consentCheckbox-electronicCommunication"
                    type="checkbox"
                    checked={checkingbox}
                    onChange={() => setCheckingbox(!checkingbox)}
                  />
                  <span>
                    By checking this box, I agree to use electronic records and
                    signatures and I acknowledge that I have read the related
                    consumer disclosure.
                  </span>
                </label>
              </div>

              <div className="signature-block_verify">
                <label className="signature-label">Signature</label>

                <input
                  type="text"
                  value={signedBy}
                  placeholder="Type your signature here"
                  onChange={(e) => setSignedBy(e.target.value)}
                  className="signature-input"
                />
                <button
                  className="sign-btn_verify"
                  onClick={AddSignofpatient}
                  disabled={!checkingbox || !signedBy.trim()}
                >
                  Sign Consent
                </button>
                <div className="signature-status"></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ConsentForms;
